import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-21/task-01";

const task: Slide = {
  titleHtml:
    "Indicate which measures will yield good sound insulation</br>of a door, and which will lead to a bad one.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
